import { render, staticRenderFns } from "./DeliveryNew_AddItemInvoice.vue?vue&type=template&id=938e0556&"
import script from "./DeliveryNew_AddItemInvoice.vue?vue&type=script&lang=js&"
export * from "./DeliveryNew_AddItemInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports